import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string'
import * as actions from '../../reducers/formTable';
import CustomTable2 from '../../components/TableCardForm'
import { Link } from 'react-router-dom';
import { fetchDispath } from '../../functions/fetch'
import { enqueueSnackbar } from '../../reducers/notifier'
import FilterArray from '../../components/FilterArray';
import {
  Typography, Menu, MenuItem, Button, Fade,
  Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText,
  FormControl, FormLabel, RadioGroup, Radio, FormControlLabel
} from "@mui/material";
import PageListColumn from '../../components/PageListFilterColumn'
import { formInitialize } from '../../reducers/form';
import { changeTypeMaterialsMulti,convertMaterialToWork } from '../../api/material'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
  },
  butt: {
    display: 'flex',
  },
  grow: {
    flexGrow: 1
  },
  row: {
    color: '#000000',
    '&$selected': {
      color: '#aaaaaa'
    }
  },
  selected: {},
  table: {
    height: 700
  },
  cell: {
    // fontSize: '0.8rem'
  },
  pagination: {},
  container: {
    height: '70vh'
  }
}));

export default function PageListCustom({
  classes,
  name,
  columns,
  createItem = false,
  deleteItem = false,
  idName = 'id',
  tableProps,
  click = true,
  csv = true,
  headerInit = {},
  notLoad = false,
  notClear = false,
  pagination = true,
  reload = false,
  reloadFunc,
  onClickFunction,
  filterProps = [],
  title = '',
  deleteMulti = false,
  deleteMultiProps = 'arr',
  location,
  match,
  history,
  loadAPI,
  deleteAPI,
  disabledDelete,
  headerLink,
  headerObj,
  tableActions = {},
  additionalActions = []
}) {
  const classesPage = { ...useStyles(), ...classes }
  const dispatch = useDispatch();
  const searchLocation = location.search
  let obj = queryString.parse(searchLocation)
  if (pagination && !obj.limit) {
    obj.limit = '100'
    obj.offset = '0'
  }
  const [search, setSearch] = useState(obj)
  const [searchOld, setSearchOld] = useState('-1')
  const [arrDelete, setArrDelete] = useState([])
  const [arrHidden, setArrHidden] = useState([])
  const formTable = useSelector(state => state.formTable[name] || state.formTable.default)
  const firstHistoryLength = React.useRef(history?.length || 0)
  const load = useCallback((search) => {
    dispatch(fetchDispath({
      querty: {
        ...search,
        ...loadAPI.querty
      },
      param: loadAPI.param,
      progress: true,
      request: loadAPI.request,
      transform: loadAPI.transform,
    })).then(res => {
      dispatch(actions.loadFormTable({ ...res }, { name: name, id: idName }))
      dispatch(actions.setSortFormTable({ sortBy: 'number', sortDirection: 'desc' }, { name: name }))
    }).catch(err => console.log(err))
  }, [dispatch, loadAPI, name, idName])
  useEffect(() => {
    dispatch(actions.initFormTable({ name: name, header: { ...headerInit } }))
    return () => {
      dispatch(actions.clearFormTable(name))
    }
  }, [dispatch, name, notLoad, notClear])
  useEffect(() => {
    if (notLoad) return;
    if (searchLocation === '' && pagination) {
      load(search)
      return;
    }
    if (searchLocation !== searchOld) {
      const searchNew = queryString.parse(searchLocation)
      setSearch(searchNew)
      setSearchOld(searchLocation)
      load(searchNew)
      return;
    }
    if (reload) {
      reloadFunc()
      load(queryString.parse(searchLocation))
      return;
    }
  }, [dispatch, notLoad, searchLocation, load, reload, reloadFunc, searchOld, pagination, search])

  const deleteCustom = (param, body) => {
    dispatch(fetchDispath({
      param,
      body,
      progress: false,
      request: deleteAPI
    }))
      .then((res) => {
        let msg = {}
        if (res) {
          load(search)
          msg = {
            message: `success`,
            options: { variant: 'success' }
          }
        }
        else {
          msg = {
            message: `not deleted`,
            options: { variant: 'error' }
          }
        }
        dispatch(enqueueSnackbar(msg))
      })
  }
  const handleDeleteOne = (id) => deleteCustom({ id: id })
  const handleDeleteMulti = () => {
    deleteCustom(undefined, {
      [deleteMultiProps]: arrDelete.map(id => formTable.byId[id][idName])
    })
    setArrDelete([])
  }
  const linkURL = (id) => `${match.url}/${id}`
  const editFilterValue = (field, value) => {
    let searchNew = {
      ...search,
      limit: 25,
      offset: 0,
      [field]: value
    };
    setSearch(searchNew)
    history.push(`?${queryString.stringify(searchNew)}`)
  }
  const addToArrDelete = (id) => {
    if (arrDelete.includes(id)) {
      setArrDelete(arrDelete.filter(e => id !== e))
    }
    else {
      setArrDelete([...arrDelete, id])
    }
  }
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      if (disabledDelete) {
        const arr = []
        formTable.allIds.forEach(key => {
          const obj = formTable.byId[key]
          const addDel = disabledDelete(obj)
          if (!addDel) arr.push(key)
        })
        setArrDelete(arr)
        return;
      }
      setArrDelete(formTable.allIds)
      return;
    }
    setArrDelete([])
  };
  const handleSort = (sortBy, sortDirection) => {
    dispatch(actions.setSortFormTable({ sortBy, sortDirection }, { name: name }))
  }
  const handleChangePage = (event, pageNew) => {
    let searchQuery = queryString.parse(searchLocation)
    const { limit, offset } = search
    const page = offset / limit
    if (page !== pageNew && event) {
      searchQuery.offset = limit * pageNew
      if (typeof searchQuery.limit === 'undefined') searchQuery.limit = limit
      history.push(`?${queryString.stringify(searchQuery)}`)
      window.scrollTo(0, 0)
    }
  };
  const handleChangeRowsPerPage = event => {
    let searchQuery = queryString.parse(searchLocation)
    if (Number(searchQuery.limit) !== Number(event.target.value)) {
      searchQuery.limit = event.target.value
      searchQuery.offset = 0
      history.push(`?${queryString.stringify(searchQuery)}`)
    }
  };
  const toLinkAdd = React.forwardRef((props, ref) => (
    <Link ref={ref} to={`${match.url}/add`} {...props} />
  ));
  const hideColumn = (id, add) => {
    if (add) {
      setArrHidden([...arrHidden, id])
    }
    else {
      setArrHidden(arrHidden.filter(e => id !== e))
    }
  }
  return (
    <React.Fragment>
      {title !== '' && <Typography variant='h6'>{title}</Typography>}
      <div className={classesPage.header}>
        {createItem && <Button component={toLinkAdd} color="primary" >Добавить</Button>}
        {headerLink}
        <ActionSelected
          arrSelected={arrDelete.map(id => formTable.byId[id][idName])}
          history={history}
          match={match}
        />
        <ChangeOurCustomer
          arrSelected={arrDelete.map(id => formTable.byId[id][idName])}
          reload={() => load(search)}
          match={match}
          clearDelete={() => setArrDelete([])}
        />
        <ConvertToWork
          arrSelected={arrDelete.map(id => formTable.byId[id][idName])}
          reload={() => load(search)}
          match={match}
          clearDelete={() => setArrDelete([])}
        />
        <div className={classesPage.grow} />
        <ActionDelete
          arrSelected={arrDelete.map(id => formTable.byId[id][idName])}
          handleDeleteMulti={handleDeleteMulti}
          deleteItem={deleteItem}
        />
        {csv && <PageListColumn
          csv={csv}
          columns={columns}
          arrHidden={arrHidden}
          hideColumn={hideColumn}
          additionalActions={additionalActions}
          name={name}
        />}
      </div>
      {headerObj}
      {filterProps.length > 0 && <FilterArray
        change={editFilterValue}
        arr={filterProps}
        name={name}
      />}
      <CustomTable2
        idName={idName}
        classes={classesPage}
        tableActions={{
          onDeleteRow: (deleteItem) ? handleDeleteOne : undefined,
          onClickRow: (click) ? linkURL : undefined,
          onClickFunction: onClickFunction,
          disabledDelete: disabledDelete,
          addToArrDelete: addToArrDelete,
          handleSelectAllClick: handleSelectAllClick,
          setSort: handleSort,
          ...tableActions
        }}
        tableHead={columns}
        tableData={formTable}
        history={history}
        search={{ limit: search.limit, page: search.offset / search.limit }}
        deleteMulti={deleteMulti}
        arrDeleteMulti={arrDelete}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        arrHidden={arrHidden}
        goBack={true}
        firstHistoryLength={firstHistoryLength}
        {...tableProps}
      />
    </React.Fragment>
  )
}
function ConvertToWork({ arrSelected, reload, clearDelete,match }) {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const handleOk = () => {
    dispatch(fetchDispath({
      param: undefined,
      body: {
        arr: arrSelected,
      },
      progress: false,
      request: convertMaterialToWork(match.params.id)
    }))
      .then((res) => {
        let msg = {}
        if (res) {
          reload()
          clearDelete()
          msg = {
            message: `Успех`,
            options: { variant: 'success' }
          }
        }
        else {
          msg = {
            message: `Операция не выполнена`,
            options: { variant: 'error' }
          }
        }
        setOpen(false)
        dispatch(enqueueSnackbar(msg))
      })
  }

  return <React.Fragment>
    <Button onClick={() => setOpen(true)} disabled={arrSelected.length === 0} color="primary">Создать работу</Button>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>
        Создать работу по материалу
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Вы уверены что хотите создать новую работу?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Отмена</Button>
        <Button onClick={handleOk}>Создать</Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
}
function ChangeOurCustomer({ arrSelected, reload, clearDelete,match }) {
  const [open, setOpen] = useState(false)
  const [customer, setCustomer] = useState('false')
  const dispatch = useDispatch()
  const handleOk = () => {
    dispatch(fetchDispath({
      param: undefined,
      body: {
        arr: arrSelected,
        customer: customer === 'true' ? true : false
      },
      progress: false,
      request: changeTypeMaterialsMulti(match.params.id)
    }))
      .then((res) => {
        let msg = {}
        if (res) {
          reload()
          clearDelete()
          msg = {
            message: `Успех`,
            options: { variant: 'success' }
          }
        }
        else {
          msg = {
            message: `Операция не выполнена`,
            options: { variant: 'error' }
          }
        }
        setOpen(false)
        dispatch(enqueueSnackbar(msg))
      })
  }

  return <React.Fragment>
    <Button onClick={() => setOpen(true)} disabled={arrSelected.length === 0} color="primary">Изменить свой чужой</Button>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>
        Изменить тип материала
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Выберите тип материала.
          Внимание изменение возможно только если нет документа покупки
        </DialogContentText>
        <FormControl>
          <FormLabel>Тип изменений</FormLabel>
          <RadioGroup
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
          >
            <FormControlLabel value={'false'} control={<Radio />} label="Свои->Давальческие" />
            <FormControlLabel value={'true'} control={<Radio />} label="Давальческие->Свои" />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Отмена</Button>
        <Button onClick={handleOk}>Изменить</Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
}
function ActionSelected({ arrSelected, history, match }) {
  const [open, changeOpen] = useState(false)
  const [anchorRef, changeRef] = useState(null)
  const dispatch = useDispatch()
  const addToForm = () => dispatch(formInitialize({ arr: arrSelected }, { name: 'materialSelected' }))
  const handleToggle = (e) => {
    changeOpen(!open)
    changeRef(!anchorRef ? e.currentTarget : null)
  }
  const handleClose = () => {
    changeOpen(false)
    changeRef(null)
  }
  const handleBuy = () => {
    addToForm();
    history.push(`/projects/${match.params.id}/shipment/materials/add`)
  }
  const handleOrderProvider = () => {
    addToForm();
    history.push(`/projects/${match.params.id}/order/provider/add`)
  }
  const handleOrder = () => {
    addToForm();
    history.push(`/projects/${match.params.id}/receipt/materials/add`)
  }
  return <React.Fragment>
    <Button onClick={handleToggle} disabled={arrSelected.length === 0} color="primary">Создать документ</Button>
    <Menu
      id="fade-menu"
      anchorEl={anchorRef}
      keepMounted
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <MenuItem onClick={handleOrderProvider} >Заказ поставщику</MenuItem>
      <MenuItem onClick={handleBuy} >Закупки</MenuItem>
      <MenuItem onClick={handleOrder} >Давальческие материалы</MenuItem>
    </Menu>
  </React.Fragment>
}

function ActionDelete({ arrSelected, handleDeleteMulti, deleteItem }) {
  return <Button onClick={() => { handleDeleteMulti(); }} disabled={!deleteItem && arrSelected?.length === 0} color="primary">Удалить</Button>
}